import { render } from "./App.vue?vue&type=template&id=e1236512&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=e1236512&lang=css"

import exportComponent from "/var/www/app_server_flask/temp/temp_app_ingegno_energy-saving_1764367324033741919/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__